import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { orders as ordersAPI } from 'api';
import reducers, { getIsFetching, getOrderNumber } from './reducers';

const OrdersApiHOC = () => WrappedComponent => compose(
  connect(
    state => ({
      _ordersApiHOC_state: {
        orderNumber: getOrderNumber(state),
        isOrderFetching: getIsFetching(state),
      },
    }),

    dispatch => ({
      _ordersApiHOC_actions: {
        postOrder: bindActionCreators(ordersAPI.actions.postOrder, dispatch),
      },
    }),
  ),

  /* eslint-disable no-underscore-dangle */
  withProps(
    props => ({
      ordersApiHOC: {
        ...props._ordersApiHOC_state,
        ...props._ordersApiHOC_actions,
      },
    }),
  ),
  /* eslint-enable no-underscore-dangle */
)(WrappedComponent);

export { reducers };

export default OrdersApiHOC;



// WEBPACK FOOTER //
// ./src/components/apiHOCs/OrdersApiHOC/index.js